import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ComboboxModule } from '@shared/combobox/combobox.module';
import { SharedModule } from '@shared/shared.module';
import { ToggleOptionModule } from '@shared/toggle-option/toggle-option.module';
import { UiCoreModule } from '@ui-core/ui-core.module';

import { AddEditPetComponent } from './add-edit-pet.component';

@NgModule({
	declarations: [AddEditPetComponent],
	imports: [
		CommonModule,
		SharedModule,
		ComboboxModule,
		ReactiveFormsModule,
		UiCoreModule,
		ToggleOptionModule
	],
	exports: [AddEditPetComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddEditPetModule { }
